// import { useEffect, useState } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import axios from "axios";

// const EditDomain = () => {
//   const { pubId, domainId } = useParams(); // Get domain ID from URL
//   const navigate = useNavigate();
//   const [domainData, setDomainData] = useState({
//     name: "",
//     domain: "",
//     account_id: "",
//     site_id: "",
//     status: "",
//   });

//   // Fetch domain details
//     const fetchDomain = async () => {
//       try {
//         const token = localStorage.getItem("token");
//         const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/getSiteInfo/${pubId}/${domainId}`, {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//             Accept: "application/json",
//           },
//         });

//         if (response.status === 200 && response.data?.data?.length > 0) {
//           const siteData = response.data.data[0];
//             console.log(response);            
//           setDomainData({
//             name: siteData.name,
//             domain: siteData.domain,
//             account_id: siteData.account_id,
//             site_id: siteData.id,
//             status: siteData.status,
//           });
//         }
//       } catch (error) {
//         console.error("Error fetching domain details:", error);
//       }
//     };
//     useEffect(() => {
//     fetchDomain();
//     console.log(domainData);    
//   }, [pubId, domainId]);

//   // Handle form submission
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       debugger;
//       const token = localStorage.getItem("token");
//       const requestData = {
//         account_id: domainData.account_id,
//         site_id: domainData.site_id,
//         status: domainData.status,
//         name: domainData.name,
//         domain: domainData.domain,
//       };
//       const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/admin/updateSiteInfo`, requestData, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//           Accept: "application/json",
//         },
//       });

//       if (response.status === 200) {
//         alert("Domain updated successfully!");
//         navigate(`/domain-list/${pubId}`);
//       }
//     } catch (error) {
//       if (error.response?.status === 401) {
//         console.error("Unauthorized! Token might be expired.");
//         localStorage.removeItem("token");
//         navigate("/");
//       } else {
//         console.error("Error fetching data:", error);
//       }
//       console.error("Error updating domain:", error);
//     }
//   };

//   return (
//     <section className="mainContainer">
//       <div className="container mt-4">
//         <h2>Edit Domain</h2>
//         <form onSubmit={handleSubmit}>
//           <div className="mb-3">
//             <label className="form-label">Name</label>
//             <input
//               type="text"
//               className="form-control"
//               value={domainData.name}
//               onChange={(e) => setDomainData({ ...domainData, name: e.target.value })}
//               required
//             />
//           </div>

//           <div className="mb-3">
//             <label className="form-label">Domain</label>
//             <input
//               type="text"
//               className="form-control"
//               value={domainData.domain}
//               onChange={(e) => setDomainData({ ...domainData, domain: e.target.value })}
//               required
//             />
//           </div>

//           <button type="submit" className="btn btn-success">
//             Save Changes
//           </button>
//           <button type="button" className="btn btn-secondary ms-2" onClick={() => navigate(-1)}>
//             Cancel
//           </button>
//         </form>
//       </div>
//     </section>
//   );
// };

// export default EditDomain;

import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import "./editDomain.css";
import { getUserRole } from "../../utils/auth";

const EditDomain = () => {
  const { pubId, domainId } = useParams();
  const navigate = useNavigate();

  const role = getUserRole();
  const isViewOnly = role === "account_manager"

  const [domainData, setDomainData] = useState({
    name: "",
    domain: "",
    account_id: "",
    site_id: "",
    status: "",
  });

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  // Fetch domain details
  const fetchDomain = async () => {
    try {
      setLoading(true);
      setError("");

      const token = localStorage.getItem("token");

      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/admin/getSiteInfo/${pubId}/${domainId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      if (response.status === 200 && response.data?.data?.length > 0) {
        const siteData = response.data.data[0];

        setDomainData({
          name: siteData.name || "",
          domain: siteData.domain || "",
          account_id: siteData.account_id || "",
          site_id: siteData.id || "",
          status: siteData.status || "",
        });
      } else {
        setError("Domain details not found.");
      }
    } catch (error) {
      console.error("Error fetching domain details:", error);

      if (error.response?.status === 401) {
        localStorage.removeItem("token");
        navigate("/");
      } else {
        setError(
          error.response?.data?.message ||
            "Unable to load domain details. Please try again."
        );
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDomain();
  }, [pubId, domainId]);

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    setSaving(true);
    setMessage("");
    setError("");

    try {
      const token = localStorage.getItem("token");

      const requestData = {
        account_id: domainData.account_id,
        site_id: domainData.site_id,
        status: domainData.status,
        name: domainData.name,
        domain: domainData.domain,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/admin/updateSiteInfo`,
        requestData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      if (response.status === 200) {
        setMessage("Domain updated successfully!");

        setTimeout(() => {
          navigate(`/domain-list/${pubId}`);
        }, 1200);
      }
    } catch (error) {
      console.error("Error updating domain:", error);

      if (error.response?.status === 401) {
        localStorage.removeItem("token");
        navigate("/");
      } else {
        setError(
          error.response?.data?.message ||
            "Failed to update domain. Please try again."
        );
      }
    } finally {
      setSaving(false);
    }
  };

  return (
    <section className="mainContainer edit-domain-page">
      <div className="edit-domain-container">

        {/* Page Header */}
        <div className="page-header">
          <button
              type="button"
              className="back-button"
              onClick={() => navigate(-1)}
              aria-label="Go back"
            >
              ←
            </button>
          <div>
            <h2>Edit Domain</h2>
            <p>Update the domain information below.</p>
          </div>
        </div>

        {/* Success Message */}
        {message && (
          <div className="domain-alert domain-alert-success">
            <span className="alert-icon">✓</span>
            {message}
          </div>
        )}

        {/* Error Message */}
        {error && (
          <div className="domain-alert domain-alert-error">
            <span className="alert-icon">!</span>
            {error}
          </div>
        )}

        {/* Loading */}
        {loading ? (
          <div className="domain-form-card loading-card">
            <div className="loading-spinner"></div>
            <p>Loading domain details...</p>
          </div>
        ) : (
          <div className="domain-form-card">

            <form onSubmit={handleSubmit}>
            <fieldset disabled={isViewOnly} className="publisher-view-fieldset">
              {/* Domain Name */}
              <div className="form-group">
                <label htmlFor="domainName">
                  Domain Name
                  <span>*</span>
                </label>

                <input
                  id="domainName"
                  type="text"
                  className="domain-input"
                  value={domainData.domain}
                  onChange={(e) =>
                    setDomainData({
                      ...domainData,
                      domain: e.target.value,
                    })
                  }
                  placeholder="Enter domain name"
                  required
                />

                <small>
                  Example: https://www.example.com
                </small>
              </div>

              {/* Name */}
              <div className="form-group">
                <label htmlFor="publisherName">
                  Publisher Name
                  <span>*</span>
                </label>

                <input
                  id="publisherName"
                  type="text"
                  className="domain-input"
                  value={domainData.name}
                  onChange={(e) =>
                    setDomainData({
                      ...domainData,
                      name: e.target.value,
                    })
                  }
                  placeholder="Enter publisher name"
                  required
                />
              </div>
            </fieldset>
              {/* Buttons */}
            { role !== "account_manager" ? 
              <div className="form-actions">

                <button
                  type="submit"
                  className="save-domain-btn"
                  disabled={saving}
                >
                  {saving ? (
                    <>
                      <span className="button-spinner"></span>
                      Saving...
                    </>
                  ) : (
                    <>
                      ✓ Save Changes
                    </>
                  )}
                </button>

                <button
                  type="button"
                  className="cancel-domain-btn"
                  onClick={() => navigate(-1)}
                  disabled={saving}
                >
                  Cancel
                </button>

              </div> : ''
            }
            </form>
          </div>
        
        )}
      </div>
    </section>
  );
};

export default EditDomain;